<div class="row">
  <div class="col-xs-12 text-center">
    <!-- Il faut mettre [src] entre crochet car on lie cette source à la propriété dans le TypeScript -->
    <img style="max-width: 300px; max-height: 300px" *ngIf="book.photo" [src]="book.photo">
    <h1>{{ book.title }}</h1>
    <!-- Ajouter un ngIf pour que le By n'apparaisse pas en avance -->
    <h3 *ngIf="book.author">{{ 'By ' + book.author }}</h3>
    <br>
    <button class="btn btn-default" (click)="onBack()">Back</button>
  </div>
</div>